import type { SVGProps } from "react";
export interface CoinInsertIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function CoinInsertIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: CoinInsertIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M20.875 10V6c0-1.036-.84-1.875-1.875-1.875H5c-1.036 0-1.875.84-1.875 1.875v4c0 1.036.84 1.876 1.875 1.876h.07l.116.005a1.125 1.125 0 0 1 0 2.239l-.116.006H5A4.125 4.125 0 0 1 .875 10V6A4.125 4.125 0 0 1 5 1.875h14A4.125 4.125 0 0 1 23.125 6v4A4.125 4.125 0 0 1 19 14.127h-.07a1.125 1.125 0 0 1 0-2.25H19c1.035 0 1.874-.84 1.875-1.875Z"
      />
      <path
        fill={color}
        d="M17.875 14a5.875 5.875 0 1 0-11.75 0 5.875 5.875 0 0 0 11.75 0m2.25 0a8.125 8.125 0 0 1-16.25 0 8.1 8.1 0 0 1 2.517-5.875H5.5a1.125 1.125 0 0 1 0-2.25h13a1.125 1.125 0 0 1 0 2.25h-.89a8.1 8.1 0 0 1 2.515 5.876Zm-8.828-1.722.005.051.001.006.002.003a.4.4 0 0 0 .061.056c.134.097.402.21.854.3l.235.054c1.184.305 2.499 1.16 2.499 2.776 0 1.231-.783 2.224-1.843 2.64a1.123 1.123 0 0 1-2.22.024 2.9 2.9 0 0 1-1.713-1.608l-.074-.193-.03-.112a1.125 1.125 0 0 1 2.124-.706l.042.107.031.075c.039.076.1.154.186.218.104.078.272.156.543.156.454 0 .703-.325.704-.601 0-.096-.03-.182-.15-.289a1.4 1.4 0 0 0-.513-.268l-.262-.067c-.563-.113-1.21-.304-1.736-.687-.583-.425-.996-1.076-.996-1.937q0-.053.005-.105v-.003h.001c.047-1.16.853-1.987 1.837-2.345a1.124 1.124 0 0 1 2.218-.012c.84.299 1.428.923 1.715 1.61l.072.192.03.111a1.125 1.125 0 0 1-2.122.708l-.042-.107-.032-.075a.64.64 0 0 0-.185-.22c-.104-.077-.272-.155-.543-.155a.9.9 0 0 0-.575.185c-.113.094-.129.174-.129.213z"
      />
    </svg>
  );
}
